import { pieces, ALL_PIECE_TYPES } from '../constants/pieces';

// Returns which opponent pieces the selected piece beats, ties, and loses to.
export function getBattleInfo(selected) {
  const beats = [];
  const losesTo = [];
  const ties = [];
  for (const p of ALL_PIECE_TYPES) {
    let outcome;
    if (selected === "SP" && p === "P") outcome = "lose";
    else if (selected === "P" && p === "SP") outcome = "win";
    else if (selected === "F" && p === "F") outcome = "tie";
    else {
      const diff = pieces[selected] - pieces[p];
      if (diff > 0) outcome = "win";
      else if (diff < 0) outcome = "lose";
      else outcome = "tie";
    }
    if (outcome === "win") beats.push(p);
    else if (outcome === "lose") losesTo.push(p);
    else ties.push(p);
  }
  return { beats, losesTo, ties };
}

// Returns "attacker" | "defender" | "tie"
export function calculateBattleOutcome(attackerPiece, defenderPiece) {
  // Special rule: Private beats Spy
  if (attackerPiece === "SP" && defenderPiece === "P") return "defender";
  if (attackerPiece === "P" && defenderPiece === "SP") return "attacker";
  // Both flags: tie
  if (attackerPiece === "F" && defenderPiece === "F") return "tie";
  // Normal ranking
  const diff = pieces[attackerPiece] - pieces[defenderPiece];
  if (diff > 0) return "attacker";
  if (diff < 0) return "defender";
  return "tie";
}
